import { ref, onMounted, watch } from 'vue';
import { useArdhisasaTicketsStore } from 'dashboard/stores/ardhisasaTickets';

/**
 * Shared auth gate for all Ardhisasa modules.
 * Manages sign-in modal visibility and token checks.
 * Each module is responsible for its own data loading
 * by watching store.isAuthenticated.
 */
export function useArdhisasaAuth() {
  const store = useArdhisasaTicketsStore();
  const showAuth = ref(false);

  function handleAuthenticated() {
    showAuth.value = false;
  }

  function dismissAuth() {
    showAuth.value = false;
  }

  onMounted(() => {
    if (!store.isAuthenticated) showAuth.value = true;
  });

  // Re-open sign-in if token expires mid-session
  watch(
    () => store.isAuthenticated,
    val => {
      if (!val) showAuth.value = true;
    }
  );

  return { showAuth, handleAuthenticated, dismissAuth, store };
}
